import { env } from 'src/env';
import { Button } from 'src/v2/commonComponents/Button';
import { ArrowLeft } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import styles from './AddOnGoBackButton.module.scss';

export const AddOnGoBackButton = () => {
  const handleBackButtonClick = () => {
    window.location.href = env.REACT_APP_SUPER_NINJA_URL;
  };

  return (
    <div className={styles.root}>
      <Button color="transparent" shape="round" onClick={handleBackButtonClick}>
        <ArrowLeft size={SVG_SIZE_M} />
      </Button>
      <span className={styles.title}>On-demand</span>
    </div>
  );
};
